module.exports = __webpack_public_path__ + "static/media/riflessioni.be5ec29c.jpg";